import { CommonModule } from "app/common.module";
import { NgModule } from "@angular/core";
import { InfoPostMainComponent } from "./infopost-main.component";
import { RouterModule } from "@angular/router";
import { InfopostNavContainerModule } from "app/components/app-common-views/infopost-nav-container/infopost-nav-container.module";
import { InfoPostTspSelectorModule } from "app/components/infopost-tsp-selector/infopost-tsp-selector.module";
import { HeaderModule } from "app/components/app-common-views/header/header.module";
import { NavContainerModule } from "app/components/app-common-views/nav-container/nav-container.module";
import { LoadingSpinnerModule } from "shared/components/loading-spinner/loading-spinner.module";
import { PipelineInfoCardComponent } from "../../components/pipeline-info-card/pipeline-info-card.component";
import { InfopostNoticeInfoCardComponent } from "../../components/infopost-notice-info-card/infopost-notice-info-card.component";
import { InfopostPipelineMapComponent } from "../../components/infopost-pipeline-map/infopost-pipeline-map.component";
import { ErrorPanelModule } from "shared/components/error-panel/error-panel.module";

@NgModule({
    declarations: [
        InfoPostMainComponent
    ],
    imports: [
        CommonModule,
        RouterModule.forChild([
            { path: '', component: InfoPostMainComponent }
        ]),
        InfopostNavContainerModule,
        InfoPostTspSelectorModule,
        HeaderModule,
        NavContainerModule,
        LoadingSpinnerModule,
        InfopostNavContainerModule,
        InfoPostTspSelectorModule,
        ErrorPanelModule,
        PipelineInfoCardComponent,
        InfopostNoticeInfoCardComponent,
        InfopostPipelineMapComponent
    ],
    exports: [
        RouterModule
    ]
})
export class InfoPostMainModule { }